export enum Countery {
    id = '1',
    limit = 9,
    code = '+966',
    lat = 23.8859,
    lng = 45.0792,
    isoCode = 'SA',
}